export default "__VITE_ASSET__AQvGIXJc__"